import { isServer } from '@/types/common';

const isPreviewUrl = !isServer ? /preview/i.test(window.location.href) : false;

export const CLIENT_ID = process.env.NEXT_PUBLIC_KAKAO_KEY;

export const REDIRECT_URI = !isPreviewUrl
  ? process.env.NEXT_PUBLIC_KAKAO_LOGIN_REDIRECT_URI
  : process.env.NEXT_PUBLIC_KAKAO_LOGIN_REDIRECT_PREVIEW_URI;

export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code`;

export const NAVER_CLIENT_ID = process.env.NEXT_PUBLIC_NAVER_KEY;

export const NAVER_REDIRECT_URI = !isPreviewUrl
  ? process.env.NEXT_PUBLIC_NAVER_LOGIN_REDIRECT_URI
  : process.env.NEXT_PUBLIC_NAVER_LOGIN_REDIRECT_PREVIEW_URI;

export const NAVER_AUTH_URL = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${NAVER_REDIRECT_URI}&state=doctornownaver`;
